import { Component, EventEmitter, HostBinding, Input, OnInit, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { Product, ProductComposition, ProductModule } from 'src/app/models';
import { PickerType } from 'src/app/models/product-detail';
import { ContentService } from 'src/app/services/content/content.service';
import { ContentSection } from 'src/app/shared/layout/content-section';

@Component({
  selector: 'app-product-main-options',
  templateUrl: './main-options.component.html',
  styleUrls: ['./main-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatRadioModule, FormsModule, MatCheckboxModule],
})
export class ProductMainOptionsComponent extends ContentSection implements OnInit {
  @Input() module!: ProductModule;
  @Input() composition: ProductComposition;
  @Input() locked: boolean;
  @Input() highlightRequired: boolean;

  @Output() add = new EventEmitter<[ProductModule, Product, PickerType, number]>();
  @Output() remove = new EventEmitter<[ProductModule, Product, PickerType, number]>();

  @HostBinding('attr.aria-label') label = 'Vælg produkt';

  type: PickerType;
  radioValue: number;

  title: string;
  selectLabel: string;
  selectedLabel: string;

  constructor() {
    const contentService = inject(ContentService);
    super(contentService, 'productInfo');

    this.selectLabel = this.content.get('selectLabelText');
    this.selectedLabel = this.content.get('selectedLabelText');
  }

  ngOnInit() {
    const { maxPickCount, singles, name } = this.module;
    this.title = name;

    if (maxPickCount === 1) {
      this.type = 'pick-one';

      for (const product of this.module.products) {
        if (this.composition && this.composition?.moduleChoices[this.module.id]?.products[product.id]?.quantity) {
          this.radioValue = product.id;
          break;
        }
      }

      return;
    }

    if (singles) {
      this.type = 'pick-many';
    }

    if (!singles) {
      this.type = 'add';
    }
  }

  changeRadio(id: number) {
    if (this.radioValue) {
      this.removeProduct(this.getProductById(this.radioValue));
    }

    this.addProduct(this.getProductById(id));
    this.radioValue = id;
  }

  changeRadioCheck(id: number) {
    if (this.radioValue) {
      this.removeProduct(this.getProductById(this.radioValue));
    }

    if (this.module.minPickCount === 0 && this.radioValue === id) {
      this.radioValue = undefined;
      return;
    }

    this.addProduct(this.getProductById(id));
    this.radioValue = id;
  }

  changeCheck(product: Product, checked: boolean) {
    if (!checked) {
      this.removeProduct(product);
      return;
    }

    this.addProduct(product);
  }

  private getProductById(id: number) {
    return this.module.products.find((p) => p.id === id);
  }

  private addProduct(product: Product) {
    this.add.emit([this.module, product, this.type, 1]);
  }

  private removeProduct(product: Product) {
    this.remove.emit([this.module, product, this.type, 1]);
  }
}
